export interface DisableConsoleOptions {
  onlyInProduction?: boolean; // only disable when NODE_ENV is 'production' (default true)
  force?: boolean; // force disable regardless of env
  methods?: string[]; // which console methods to disable
}

export function disableConsole(options: DisableConsoleOptions = {}) {
  const { onlyInProduction = true, force = false, methods } = options;
  const isProdEnv = typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'production';

  if (onlyInProduction && !isProdEnv && !force) {
    return; // do nothing in dev by default
  }

  const noop = function() {};
  const defaultMethods = [
    'log',
    'info',
    'warn',
    'error',
    'debug',
    'trace',
    'group',
    'groupCollapsed',
    'groupEnd',
    'time',
    'timeEnd',
    'assert'
  ];

  const methodsToDisable = methods && methods.length ? methods : defaultMethods;

  // Save originals to window.__origConsole so restore is possible
  const win = window as any;
  win.__origConsole = win.__origConsole || {};

  methodsToDisable.forEach((m) => {
    try {
      if (typeof (console as any)[m] === 'function') {
        if (!win.__origConsole[m]) win.__origConsole[m] = (console as any)[m];
        (console as any)[m] = noop;
      }
    } catch (e) {
      // ignore
    }
  });
}

export function restoreConsole() {
  const win = window as any;
  if (!win.__origConsole) return;
  Object.keys(win.__origConsole).forEach((k) => {
    try {
      (console as any)[k] = win.__origConsole[k];
    } catch (e) {
      // ignore
    }
  });
  win.__origConsole = undefined;
}
